import React, {
	useEffect, useState,
} from 'react';

import {
	getPdfViewURL,
} from 'Vulture/Content';

// PdfPreview fetches a presigned inline view URL for the PDF and renders it in
// an iframe. Going through the view-url endpoint (rather than the raw S3 URL)
// forces inline rendering for legacy octet-stream PDFs, and surfaces a clean
// in-modal error for missing/inaccessible files instead of a broken viewer.
const PdfPreview = (props) => {
	const {
		fileUrl,
		accountUUID,
		label,
	} = props;
	const [ viewState, setViewState, ] = useState({
		status: 'loading',
		url:    '',
	});

	useEffect(() => {
		let cancelled = false;

		setViewState({
			status: 'loading',
			url:    '',
		});
		getPdfViewURL(fileUrl, accountUUID)
			.then((url) => {
				if (!cancelled) setViewState({
					status: 'ready',
					url,
				});
			})
			.catch(() => {
				if (!cancelled) setViewState({
					status: 'error',
					url:    '',
				});
			});
		return () => {
			cancelled = true;
		};
	}, [ fileUrl, accountUUID, ]);

	if (viewState.status === 'loading') {
		return <div className="pdf-preview-message">Loading preview…</div>;
	}
	if (viewState.status === 'error') {
		return (
			<div className="pdf-preview-message">
				This file can’t be viewed right now. It may have been moved, or you may not have access to it.
			</div>
		);
	}
	return (
		<iframe
			src={viewState.url}
			data-test-id="pdfPreviewFrame"
			title={label || 'PDF preview'}
			style={{
				width:  '100%',
				height: '100%',
				border: 'none',
			}}
		/>
	);
};

export default PdfPreview;
